import { alpha, type Components, type Theme } from "@mui/material";

export const MuiButton: Components<Theme>["MuiButton"] = {
  defaultProps: {
    onClick: () => window.alert("To be implemented"),
  },
  styleOverrides: {
    contained: ({ theme }) => {
      return {
        ...theme.typography.button,
        paddingTop: ".75rem",
        paddingBottom: ".75rem",
        paddingLeft: "1rem",
        paddingRight: "1rem",
        boxShadow: "0px 4px 20px 0px rgba(14, 18, 18, 0.06)",
        border: "1px solid rgba(255, 255, 255, 0.20)",
        borderRadius: ".75rem",
      };
    },
    outlined: ({ theme }) => {
      return {
        ...theme.typography.button,
        paddingTop: ".75rem",
        paddingBottom: ".75rem",
        paddingLeft: "1rem",
        paddingRight: "1rem",
        minWidth: "fit-content",
        borderRadius: ".75rem",
        "&:hover": {
          backgroundColor: alpha(theme.palette.primary.main, 0.08),
        },
      };
    },
    containedPrimary: ({ theme }) => {
      return {
        ...theme.typography.button,
        paddingTop: ".75rem",
        // height: '2.5rem',
        paddingBottom: ".75rem",
        boxShadow: "0px 4px 20px 0px rgba(14, 18, 18, 0.06)",
        borderRadius: ".75rem",
      };
    },
    outlinedPrimary: ({ theme }) => {
      return {
        ...theme.typography.button,
        fontWeight: 500,
        lineHeight: "1.5rem",
        border: "1px solid #D7DEF8",
        paddingLeft: "1rem",

        backgroundColor: "#fff",
        paddingBottom: ".75rem",
      };
    },
    containedSecondary: ({ theme }) => {
      return {
        ...theme.typography.button,
        color: theme.palette.secondary.dark,
      };
    },
    outlinedSecondary: ({ theme }) => {
      return {
        ...theme.typography.button,
        color: theme.palette.primary.dark,
        paddingTop: ".75rem",
        paddingBottom: ".75rem",
        paddingLeft: "1rem",
        paddingRight: "1rem",
        // border: `1.5px solid ${theme.palette.secondary.dark}`,
        border: "1px solid #C2CEF4",
        backgroundColor: "color(display-p3 1 1 1))",
      };
    },
    containedWarning: ({ theme }) => {
      return {
        ...theme.typography.button,
        color: "white",
      };
    },
    textSecondary: ({ theme }) => {
      return {
        ...theme.typography.button,
        color: theme.palette.secondary.dark,
        backgroundColor: "transparent",
      };
    },
    outlinedError: ({ theme }) => {
      return {
        border: `1.5px solid ${theme.palette.secondary.dark}`,
      };
    },
  },
};
